import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { copyUnionCallLink } from '@gem/call/tasks/copyUnionCallLink';
import { CopyIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import styles from './ShareInviteLink.styles.m.css';

interface IShareInviteLinkProps {
  call: Call;
}

export const ShareInviteLink: FC<IShareInviteLinkProps> = observer(({ call }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={(): void =>
        copyUnionCallLink({
          channelId: call.channelId || undefined,
          inviteLink: call.inviteLink,
          copyCallback: call.setInviteLink,
        })
      }
      className={styles.link}
      iconClassName={styles.icon}
      Icon={CopyIcon}
      theme="11"
      text={t('common_copy_call_link')}
      size={IconViewSizes.Large}
      iconSize={IconViewSizes.Auto}
    />
  );
});
